import React from 'react';
import PropTypes from 'prop-types';
import ChatUserAvatar from 'common/components/modules/chat/chat-user-avatar';
import SpinnerAnimation from 'common/components/modules/spinner-animation';
import Icon from 'common/components/elements/icons';
import cx from 'classnames';
import TruncateText from 'common/components/elements/truncate-text';

const ChatItem = ({
   avatars,
   name,
   onlineMembersCount,
   active,
   onClick,
   userIsTyping,
   unreadMessagesCount,
   isOnline,
   index,
   withoutAvatar,
   isGroupChat,
}) => {
   return (
      <div
         style={ {
            width: 'calc(50% - 40px)',
            // borderBottomColor: active ? 'transparent' : '#EAEDF0',
         } }
         role='presentation'
         onClick={ onClick }
         className={ cx({
            'cursor-pointer flex flex-1 py-4 px-5 items-center border-b': true,
            'bg-panel dark:bg-panel-dark border-transparent': active,
            'dark:border-divider-dark border-divider': !active,
            'border-r rounded-tr-label': active && index === 0,
            'border-l rounded-tl-label': active && index === 1,
         }) }

      >
         <>
            {
               !!withoutAvatar  && (
                  <>
                     <div
                        style={ {
                           minWidth: '40px',
                        } }
                        className='flex items-center justify-center w-10 h-10 min-w-10 rounded-full skin-primary-background'>
                        <Icon name='chat' color='major-dark' size='xl' />
                     </div>
                  </>
               )
            }
            {
               !withoutAvatar && (
                  <>
                     <div>
                        <ChatUserAvatar
                           avatarSrc={ avatars }
                           // username={ name }
                        />
                     </div>
                  </>
               )
            }
         </>
         <div
            style={ {
               width: 'calc(100% - 40px)',
            } }
            className='flex flex-col ml-3 truncate'>

            {
               userIsTyping && (
                  <SpinnerAnimation
                     className='px-4'
                  />
               )
            }
            {
               !userIsTyping && (
                  <div
                     className='flex w-full items-center'>
                     <TruncateText
                        text={ name }
                        className={ cx({
                           'leading-tight text-major dark:text-major-dark': true,
                           'notranslate': !isGroupChat,
                        }) }
                        textSize='16px'
                        fontWeight='400'
                        width={ isOnline ? 'calc(100% - 16px)' : '100%' }
                     />
                     {
                        unreadMessagesCount > 0 && (
                           <div className='chat-left-new-count bg-error dark:bg-error-dark rounded-full flex items-center justify-center ml-2'>
                              <span className='text-major-dark text-xs font-medium'> { unreadMessagesCount > 100 ? '99+' : unreadMessagesCount} </span>
                           </div>
                        )
                     }
                     {
                        !!isOnline && (
                           <span
                              style={ {
                                 minWidth: '8px',
                              } }
                              className='w-2 h-2 rounded-full bg-success dark:bg-success-dark block ml-2' />
                        )
                     }
                  </div>
               )
            }
            {
               onlineMembersCount && (
                  <span className='text-xs leading-none text-placeholder dark:text-placeholder-dark'>{onlineMembersCount} online</span>
               )
            }

         </div>

      </div>
   )
};
ChatItem.defaultProps = {
   onClick: () => {},
};
ChatItem.propTypes = {
   avatars: PropTypes.any,
   onlineMembersCount: PropTypes.any,
   name: PropTypes.string,
   active: PropTypes.bool,
   onClick: PropTypes.func,
   userIsTyping: PropTypes.bool,
   unreadMessagesCount: PropTypes.number,
   isOnline: PropTypes.any,
   index: PropTypes.number,
   withoutAvatar: PropTypes.bool,
   isGroupChat: PropTypes.bool,
};

export default ChatItem;
